<!-- StepUploadFile.vue - исправленный -->
<template>
    <div class="modal_main_load"
      :class="{ 
        modal_main_load_drag: localDragOver,
        modal_main_load_next: hasFile,
        'modal_main_load_with-icon': showStaffIcon && !hasFile
      }"
      @dragover.prevent="onDragOver"
      @dragleave.prevent="onDragLeave"
      @drop.prevent="onDrop">
      
      <!-- Состояние без файла -->
      <template v-if="!hasFile">
        <div class="modal_main_load_head">
          <span>{{ title }}</span>
          <span v-if="subtitle">{{ subtitle }}</span>
        </div>
        
        <!-- Специальная иконка для штатного расписания -->
        <div v-if="showStaffIcon" class="staff-icon">
          <svg width="56" height="70" viewBox="0 0 56 70" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M27.9996 57.4308V34.8585M27.9996 34.8585L16.4284 42.3826M27.9996 34.8585L39.5709 42.3826M31.8567 1.00327C31.4884 1 31.0748 1 30.6021 1H13.3434C9.02309 1 6.86131 1 5.21116 1.82008C3.75964 2.54144 2.58038 3.69165 1.84079 5.1074C1 6.71689 1 8.82541 1 13.0393V56.6791C1 60.893 1 62.9989 1.8408 64.6084C2.58038 66.0241 3.75964 67.1763 5.21116 67.8977C6.85971 68.717 9.01891 68.717 13.3309 68.717L42.6685 68.717C46.9804 68.717 49.1364 68.717 50.785 67.8977C52.2365 67.1763 53.4197 66.0241 54.1593 64.6084C54.9992 63.0004 54.9992 60.8975 54.9992 56.6919V24.7976C54.9992 24.3359 54.9992 23.932 54.9956 23.5723M31.8567 1.00327C32.9584 1.01305 33.6554 1.05209 34.3208 1.20789C35.1079 1.39221 35.8598 1.69698 36.55 2.10951C37.3282 2.57467 37.9965 3.22645 39.3298 4.52693L51.3851 16.2852C52.7193 17.5865 53.3826 18.2353 53.8597 18.9946C54.2826 19.6678 54.5956 20.4019 54.7845 21.1696C54.9442 21.8183 54.9852 22.4983 54.9956 23.5723M31.8567 1.00327V11.5337C31.8567 15.7476 31.8567 17.8531 32.6975 19.4626C33.4371 20.8784 34.6164 22.0317 36.0679 22.753C37.7164 23.5723 39.8756 23.5723 44.1875 23.5723H54.9956M54.9956 23.5723H55"
              stroke="#283F60" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        
        <div class="modal_main_load_content">
          <div class="modal_main_load_content_btn" style="cursor: pointer;" @click="triggerFileInput">
            <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M17 10.25V15.5C17 16.6046 16.1046 17.5 15 17.5H3C1.89543 17.5 1 16.6046 1 15.5V10.25M8.99999 1.5V12.75M8.99999 1.5L13.5 6M8.99999 1.5L4.5 6"
                stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              </path>
            </svg>
            <span>Загрузить файл</span>
            <input 
              type="file" 
              ref="fileInput" 
              @change="handleFileUpload" 
              :accept="acceptedTypes"
              style="display: none" 
            />
          </div>
        </div>
        
        <div class="modal_main_load_footer" v-if="footerText">
          {{ footerText }}
        </div>
      </template>
      
      <!-- Состояние с файлом -->
      <div class="file_card" v-else>
        <div class="file_card_img">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"
            fill="none" stroke="#8A75FF" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round">
            <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
            <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
            <path d="M10 9H8"></path>
            <path d="M16 13H8"></path>
            <path d="M16 17H8"></path>
          </svg>
        </div>
        <div class="file_card_content">
          <div class="file_card_content_head" :class="{ 'marquee': isFileNameLong }">
            <div class="marquee-wrapper">
              <span class="marquee-text">{{ fileData.name }}</span>
              <span class="marquee-text" v-if="fileData.name && fileData.name.length > 30">{{ fileData.name }}</span>
            </div>
          </div>
          <div class="file_card_content_text">
            {{ fileData.size }}
          </div>
        </div>
        <div class="file_card_content_close" @click.stop="clearFile">
          <!-- Крестик через CSS псевдоэлементы -->
        </div>
      </div>
      
      <!-- Кнопка продолжения -->
      <div class="modal_main_load_content_btn continue-btn" 
          @click="continueWithFile" 
          style="cursor: pointer; margin-top: 16px;"
          v-if="hasFile && showContinue && !isComparison">
        <span>Продолжить</span>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'StepUploadFile',
    props: {
      isComparison: {
        type: Boolean,
        default: false
      },
      dragOver: {
        type: Boolean,
        default: false
      },
      fileData: {
        type: Object,
        default: () => ({})
      },
      title: {
        type: String,
        default: 'Выберите файл'
      },
      subtitle: {
        type: String,
        default: ''
      },
      footerText: {
        type: String,
        default: 'PDF, DOCX или TXT до 25 МБ'
      },
      acceptedTypes: {
        type: String,
        default: '.pdf,.docx,.txt'
      },
      uploadTarget: {
        type: [String, Number],
        required: true
      },
      showContinue: {
        type: Boolean,
        default: true
      },
      maxSizeMB: {
        type: Number,
        default: 25
      },
      showStaffIcon: {
        type: Boolean,
        default: false
      }
    },
    emits: [
      'update:drag-over', 
      'update:file-data', 
      'file-upload', 
      'drag-over-event', 
      'drag-leave-event', 
      'drop-event',
      'continue',
      'error'
    ],
    computed: {
      localDragOver: {
        get() {
          return this.dragOver
        },
        set(value) {
          this.$emit('update:drag-over', value)
        }
      },
      hasFile() {
        return this.fileData && Object.keys(this.fileData).length > 0
      },
      isFileNameLong() {
        return this.fileData.name && this.fileData.name.length > 30
      }
    },
    methods: {
      continueWithFile() {
          this.$emit('continue-with-file', {
          file: this.fileData.file,
          target: this.uploadTarget
        })
      },
      triggerFileInput() {
        this.$refs.fileInput.click()
      },
      
      handleFileUpload(event) {
        const file = event.target.files[0]
        if (!file) return
        
        const maxSize = this.maxSizeMB * 1024 * 1024
        if (file.size > maxSize) {
          this.$emit('error', 'Файл слишком большой')
          return
        }
        
        const fileExtension = '.' + file.name.split('.').pop().toLowerCase()
        const allowedTypes = this.acceptedTypes.split(',')
        if (!allowedTypes.includes(fileExtension)) {
          this.$emit('error', 'Неподдерживаемый тип файла')
          return
        }
        
        const fileInfo = {
          name: file.name,
          size: (file.size / (1024 * 1024)).toFixed(2) + ' MB',
          file: file,
          type: fileExtension
        }
        
        this.$emit('update:file-data', fileInfo)
        this.$emit('file-upload', { file, target: this.uploadTarget })
      },
      
      clearFile() {
        this.$emit('update:file-data', {})
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = ''
        }
      },
      
      onDragOver() {
        this.localDragOver = true
        this.$emit('drag-over-event', this.uploadTarget)
      },
      
      onDragLeave() {
        this.localDragOver = false
        this.$emit('drag-leave-event', this.uploadTarget)
      },
      
      onDrop(event) {
        const file = event.dataTransfer.files[0]
        if (!file) return
        
        const fakeEvent = { target: { files: [file] } }
        this.handleFileUpload(fakeEvent)
        this.localDragOver = false
        this.$emit('drop-event', this.uploadTarget)
      }
    }
  }
  </script>
  
  <style scoped>
  .modal_main_load {
    width: 100%;
    height: 100%; /* На всю высоту */
    padding: 16px;
    border: 1px dashed #ffffff32;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    min-height: 400px; /* Минимальная высота как в оригинале */
    transition: all 0.3s;
  }
  
  .modal_main_load_drag {
    border-color: #8A75FF !important;
    background: #8a75ff1a;
  }
  
  .modal_main_load_next {
    border-style: solid;
    border-color: #8A75FF;
  }
  
  .modal_main_load_with-icon {
    justify-content: space-around;
  }
  
  .modal_main_load_head {
    text-align: center;
  }
  
  .modal_main_load_head span {
    display: block;
  }
  
  .modal_main_load_head span:first-child {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 8px;
  }
  
  .modal_main_load_head span:last-child {
    opacity: 0.7;
    font-size: 14px;
  }
  
  .modal_main_load_content {
    padding: 12px;
  }
  
  .modal_main_load_content_btn {
    display: flex;
    gap: 8px;
    padding: 12px 24px;
    background: #8A75FF;
    justify-content: center;
    border-radius: 24px;
    cursor: pointer;
    transition: opacity 0.3s;
  }
  
  .modal_main_load_content_btn:hover {
    opacity: 0.9;
  }
  
  .modal_main_load_footer {
    opacity: 0.5;
    font-size: 12px;
  }
  
  .staff-icon {
    margin: 20px 0;
  }
  
  .file_card {
    display: flex;
    align-items: center;
    gap: 16px;
    width: 100%;
    padding: 16px;
    background: #ffffff0a;
    border-radius: 12px;
    border: 1px solid #8A75FF;
    box-shadow: 0 0 10px 0 #8A75FF;
  }
  
  .file_card_img {
    background: #c572ba13;
    padding: 8px;
    border-radius: 50%;
    min-width: 64px;
    min-height: 64px;
    position: relative;
  }
  
  .file_card_img svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  
  .file_card_content {
    flex: 1;
    min-width: 0;
    text-align: left;
  }
  
  .file_card_content_head {
    font-weight: 600;
    margin-bottom: 8px;
    white-space: nowrap;
    overflow: hidden;
    font-size: 18px;
  }
  
  .file_card_content_text {
    font-size: 14px;
    opacity: 0.7;
  }
  
  .file_card_content_close {
    width: 40px;
    height: 40px;
    position: relative;
    cursor: pointer;
    border-radius: 50%;
    background: #fc02022c;
    flex-shrink: 0;
  }
  
  .file_card_content_close::before,
  .file_card_content_close::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 2px;
    background-color: #fc0202;
    top: 50%;
    left: 50%;
  }
  
  .file_card_content_close::before {
    transform: translate(-50%, -50%) rotate(45deg);
  }
  
  .file_card_content_close::after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
  
  .marquee {
    overflow: hidden;
  }
  
  .marquee-wrapper {
    display: flex;
    width: fit-content;
    white-space: nowrap;
    animation: marquee 12s linear infinite;
    animation-delay: 2s;
    gap: 50px;
  }
  
  .marquee-text {
    display: inline-block;
  }
  
  @keyframes marquee {
    0% { transform: translateX(0); }
    15% { transform: translateX(0); }
    85% { transform: translateX(calc(-50% - 25px)); }
    100% { transform: translateX(calc(-50% - 25px)); }
  }
  
  .continue-btn {
    margin-top: 16px;
    width: auto;
    min-width: 200px;
  }
  
  @media (max-width: 580px) {
    .file_card_img {
      display: none;
    }
    
    .file_card_content_head {
      font-size: 16px;
    }
    
    .file_card_content_text {
      font-size: 12px;
    }
    
    .modal_main_load {
      min-height: 350px; /* Чуть меньше на мобильных */
    }
  }
  </style>